export default __webpack_public_path__ + "static/media/uniswap.ba6f75a3.svg";